module.exports = __webpack_public_path__ + "img/top.3cb3a233.png";